var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};

Curriculog.ProposalForm.RichTextField = (function ($, _, Backbone, RichTextField) {

	RichTextField = Curriculog.ProposalForm.Field.extend({
		modelClass: Curriculog.ProposalForm.RichTextModel,

		initialize: function() {
			Curriculog.ProposalForm.Field.prototype.initialize.apply(this, arguments);
			if (this.mode == 'edit') {
				this.initCKEditor();
			}
		},

		/**
		 * Used to return the value of the field
		 *
		 * @returns {String} - A comma separated list of indices.
		 */
		getValue: function() {
			var $input = this.getInput();

			if (this.model.get('showMarkup')) {
				return this.model.get('value');
			}

			if (this.mode == 'edit') {
				return $input.val();
			}

			return $input.html();
		},

		/**
		 * Used to set the value of the field
		 *
		 * @returns {String} - A comma separated list of indices.
		 */
		setValue: function(value) {
			var $input = this.getInput();

			if (this.mode == 'edit') {
				return $input.val(value);
			}

			return $input.html(value);
		},

		/**
		 * This allows links in rich text areas to be clicked
		 *
		 * @param   {Event} [event]
		 */
		edit: function(event) {
			var target = $(event.target);
			if (target.is('a')) {
				return;
			}
			Curriculog.ProposalForm.Field.prototype.edit.call(this, event);
		},

		/**
		 * Initializes CKEditor when going into edit mode
		 *
		 * @returns {promise}
		 */
		afterEdit: function() {
			var promise = this.initCKEditor(),
				field = this;

			promise.done(function(){
				field.getInput().ckeditorGet().focus();
			});

			return promise;
		},

		/**
		 * Initializes ckeditor and binds essential events to it.
		 * The on('drop') event prevents files from attempting to upload.
		 *
		 * @returns {Promise} - instanceReady promise
		 */
		initCKEditor: function() {
			var $field = this.getInput(),
				view = this,
				ckeditorObj = $field.ckeditor({
					title: 'Rich Text Editor'
				});

			$field.ckeditorGet().on('instanceReady', function(event) {
				this.document.on('drop', function(event) {
					event.data.preventDefault(true);
				});
				this.document.on('change', _.bind(view.onChange, view));
				this.document.on('keyup', _.bind(view.onKeyup, view));
				this.document.on('keypress', _.bind(view.onKeypress, view));
				this.on('afterCommandExec', _.bind(view.onChange, view));
				this.on('saveSnapshot', _.bind(view.onChange, view));
				this.on('afterUndo', _.bind(view.onChange, view));
				this.on('afterRedo', _.bind(view.onChange, view));
				Backbone.trigger('form:stretch');
			});

			return ckeditorObj.promise;
		},

		/**
		 * A throttled function that updates the 'unsaved changes' cache. This
		 * function can be called as often as necessary without concern for
		 * computation overhead.
		 */
		detectChanges: function(){
			// CKEditor is magical so nothing is straight forward. It modifies
			// the html formatting of its contents slightly in some circumstances.
			// Like converting a space to a &nbsp; in a <div>. This can throw
			// off the difference calculation. Luckily they have a checkDirty()
			// function which returns whether or not the field has changed.
			// this._unsaved_changes = this.getValue() != this.model.get('value');
			this._unsaved_changes = this.getInput().ckeditorGet().checkDirty();

			// highlight the field if it has unsaved changes
			if (this._unsaved_changes) {
				this.$el.addClass('field-unsaved');
			} else {
				this.$el.removeClass('field-unsaved');
			}

		},

		/**
		 * Destroys the CKEditor instance on save/cancel to prevent a memory leak
		 */
		destroy: function() {
			if (this.mode != 'edit') {
				return $.when();
			}

			var $field = this.getInput();

			try {
				$field.ckeditorGet().destroy();
			} catch(err){
				// No ckeditor instance
			}

			return $.when();
		}

	});

	return RichTextField;

})($, _, Backbone, Curriculog.ProposalForm.RichTextField || {});
